import { gettext } from '@eventbrite/i18n';
import { getFormValidationAdornment, TextField } from '@eventbrite/marmalade';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppContext } from '../../../AppContext';
import { sanitizeText } from '../../../shared';
import { CreateAccountFormValues } from '../types';

export enum NameFormFieldTestId {
    FirstNameField = 'CreateAccountFirstNameFormField',
    LastNameField = 'CreateAccountLastNameFormField',
}

export const NameFormField = ({ type }: { type: 'firstName' | 'lastName' }) => {
    const { control } = useFormContext<CreateAccountFormValues>();
    const { isSubmittingCreateAccountForm } = useAppContext();

    return (
        <Controller
            name={type}
            control={control}
            rules={{
                required: {
                    value: true,
                    message:
                        type == 'firstName'
                            ? gettext('First name is required.').toString()
                            : gettext('Last name is required.').toString(),
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    autoComplete="off"
                    data-testid={
                        type == 'firstName'
                            ? NameFormFieldTestId.FirstNameField
                            : NameFormFieldTestId.LastNameField
                    }
                    hasError={!!error}
                    helperText={error && error.message}
                    id={`create-account-${type}-field`}
                    label={
                        type == 'firstName'
                            ? gettext('First name').toString()
                            : gettext('Last name').toString()
                    }
                    maxLength={100}
                    validationAdornment={getFormValidationAdornment({
                        hasError: !!error,
                    })}
                    {...field}
                    value={field.value || ''}
                    onChange={(value) => {
                        field.onChange({
                            target: { value: sanitizeText(value) },
                        });
                    }}
                    disabled={isSubmittingCreateAccountForm}
                    required
                />
            )}
        />
    );
};
